import React from 'react';
import { BarChart3Icon, LayoutTemplateIcon, MegaphoneIcon, Share2Icon } from 'lucide-react';
import { services, type ServiceIcon } from '../data/content';
const icons: Record<ServiceIcon, React.ComponentType<{
  className?: string;
}>> = {
  paid: MegaphoneIcon,
  social: Share2Icon,
  pages: LayoutTemplateIcon,
  analytics: BarChart3Icon
};
export function Services() {
  return <section id="services" aria-labelledby="services-heading" className="scroll-mt-16 border-b border-hairline bg-white py-20 sm:py-24" data-id="element-110" data-mp="13weg1hrg1ul7">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-111" data-mp="z31rf7mrlnsg">
        <div className="max-w-2xl" data-id="element-112" data-mp="u73ag53rn822">
          <h2 id="services-heading" className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-113" data-mp="u3yxojc8j3zs">
            Services
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-muted" data-id="element-114" data-mp="l4tzxf8hzeoo">
            Four core services, delivered as an ongoing engagement or as a
            defined scope of work.
          </p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2" data-id="element-115" data-mp="36b6g27n1ma81">
          {services.map(service => {
          const Icon = icons[service.icon];
          return <li key={service.title} className="flex h-full flex-col rounded-2xl border border-hairline bg-white p-7 shadow-card" data-id="element-116" data-mp="2xcks1wysy2zv">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-soft" data-id="element-117" data-mp="3q0qd6ktrpu08">
                  <Icon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-118" data-mp="3u2k6u95jpxqw" />
                </span>
                <h3 className="mt-5 text-lg font-semibold leading-snug text-ink" data-id="element-119" data-mp="3g2spbyftlz85">
                  {service.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-muted" data-id="element-120" data-mp="3kzsso1lacnvk">
                  {service.description[0]}
                </p>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-121" data-mp="29m770qemx4es">
                  {service.description[1]}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}